import { useUser } from '@/services/UserService'
import { useSafeAnalytics } from '@/utils/analytics'

interface ExperimentDataOptions {
  funnel?: string
  category?: string
  project_slug?: string
  [key: string]: string | number | boolean | undefined
}

export const useExperimentData = (options: ExperimentDataOptions = {}) => {
  const { userId } = useUser()
  const { user } = useSafeAnalytics()

  const getExperimentData = () => {
    const experimentData = {
      id: user()?.anonymousId,
      userId,
      timestamp: Date.now(),
      funnel: options.funnel || '',
      category: options.category || '',
      project_slug: options.project_slug || '',
      ...options,
    }

    return [
      {
        key: 'gb_data',
        value: JSON.stringify(experimentData),
      },
    ]
  }

  return getExperimentData
}
